import { MultiselectItem } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { DeviceListingFieldName } from '../../components/devices.models';

const ON_DEMAND_READ_STATUS_ITEMS: MultiselectItem[] = [
  { text: TranslateRegistry.get.FILTER.ON_DEMAND_READS.ALL, value: null },
  { text: TranslateRegistry.get.FILTER.ON_DEMAND_READS.SUCCESSFUL_LAST_24_HOURS, value: 'Completed' },
  { text: TranslateRegistry.get.FILTER.ON_DEMAND_READS.FAILED_LAST_24_HOURS, value: 'Failed' }
];

export const ON_DEMAND_READ_STATUS: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.ON_DEMAND_READS,
  items: ON_DEMAND_READ_STATUS_ITEMS,
  selected: [ON_DEMAND_READ_STATUS_ITEMS[0]],
  filterType: DeviceListingFieldName.OnDemandReadStatus,
  isMultiselect: false,
  isNonSortable: true,
  width: 195,
  isColored: false
};

const VALVE_STATUS_ITEMS: MultiselectItem[] = [
  { text: TranslateRegistry.get.FILTER.VALVE_STATUS.AUTHORIZED_TO_OPEN, value: 'ArmedAuthorizedToOpen' },
  { text: TranslateRegistry.get.FILTER.VALVE_STATUS.CLOSED, value: 'Closed' },
  { text: TranslateRegistry.get.FILTER.VALVE_STATUS.MOVING, value: 'Moving' },
  { text: TranslateRegistry.get.FILTER.VALVE_STATUS.OPEN, value: 'Open' },
  { text: TranslateRegistry.get.FILTER.VALVE_STATUS.PARTIALLY_OPEN, value: 'PartiallyOpen' },
  { text: TranslateRegistry.get.FILTER.VALVE_STATUS.READ_ERROR, value: 'ReadError' }
];

export const VALVE_STATUS: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.VALVE_STATUS,
  items: VALVE_STATUS_ITEMS,
  selected: VALVE_STATUS_ITEMS,
  filterType: DeviceListingFieldName.ValveStatus,
  isMultiselect: true,
  isNonSortable: true,
  width: 195,
  isColored: false
};
